export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/pg.8b3f45af.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};